export default "__VITE_ASSET__dab71953__"